var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: "mdi-city-variant-outline",
      show: _vm.dialog,
      maxWidth: "50%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        true || !_vm.model || !_vm.model.id
                          ? _c("v-text-field", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: "99999-999",
                                  expression: "'99999-999'",
                                },
                              ],
                              attrs: {
                                label: "Pesquisar pelo CEP",
                                autofocus: "",
                                loading: _vm.loadingFind,
                              },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.searchCity()
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "append",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              disabled: _vm.search.length < 9,
                                              icon: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.searchCity()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { color: "indigo" } },
                                              [_vm._v(" mdi-magnify ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                2478617250
                              ),
                              model: {
                                value: _vm.search,
                                callback: function ($$v) {
                                  _vm.search = $$v
                                },
                                expression: "search",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "8" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            disabled: _vm.disableFields,
                            autofocus: _vm.model.id == null,
                            error: !!_vm.errors.name,
                            "error-messages": _vm.errors.name,
                            label: "Nome*",
                          },
                          model: {
                            value: _vm.model.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "name", $$v)
                            },
                            expression: "model.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "4" } },
                      [
                        _c("sys-select-states", {
                          attrs: {
                            model: _vm.model.state_id,
                            states: _vm.states,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.state_id,
                            label: "Estado*",
                            disabled: _vm.disableFields,
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "state_id", $event)
                            },
                            "update:states": function ($event) {
                              _vm.states = $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "3" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            disabled: _vm.disableFields,
                            error: !!_vm.errors.ibge,
                            "error-messages": _vm.errors.ibge,
                            label: "Ibge*",
                          },
                          model: {
                            value: _vm.model.ibge,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "ibge", $$v)
                            },
                            expression: "model.ibge",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "3" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            disabled: _vm.disableFields,
                            error: !!_vm.errors.gia,
                            "error-messages": _vm.errors.gia,
                            label: "Gia*",
                          },
                          model: {
                            value: _vm.model.gia,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "gia", $$v)
                            },
                            expression: "model.gia",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "3" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            disabled: _vm.disableFields,
                            error: !!_vm.errors.ddd,
                            "error-messages": _vm.errors.ddd,
                            label: "DDD*",
                          },
                          model: {
                            value: _vm.model.ddd,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "ddd", $$v)
                            },
                            expression: "model.ddd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "3" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            disabled: _vm.disableFields,
                            error: !!_vm.errors.siafi,
                            "error-messages": _vm.errors.siafi,
                            label: "Siafi*",
                          },
                          model: {
                            value: _vm.model.siafi,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "siafi", $$v)
                            },
                            expression: "model.siafi",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }